import React from "react";
import ImageAttribution, { getImageSourceType } from "../ImageAttribution";
import { fallbackToApiMedia } from "../../utils/imageUtils";

const baseImageClassName =
  "object-cover h-60 fish-image-h w-full rounded shadow transition-opacity duration-300";

const ListingImage = ({
  imageUrl,
  alt,
  imageProps = {},
  imageClassName = "",
  imageFrameClassName = "",
  isLoaded,
  attributionName,
  attributionType = "species",
  attributionClassName = "",
  attributionPosition = "absolute right-0",
}) => {
  const {
    className: nativeClassName = "",
    src: nativeSrc,
    onError: nativeOnError,
    ...nativeImageProps
  } = imageProps;
  const src = nativeSrc || imageUrl;

  if (!src) {
    return null;
  }

  const opacityClassName =
    isLoaded === undefined || isLoaded ? "opacity-100" : "opacity-0";
  const hasAttribution = getImageSourceType(imageUrl) !== "unknown";

  return (
    <>
      <span
        className={[
          "block",
          hasAttribution ? "listing-header-image-frame-has-attribution" : "",
          imageFrameClassName,
        ].filter(Boolean).join(" ")}
      >
        <img
          src={src}
          alt={alt}
          loading="lazy"
          {...nativeImageProps}
          onError={(event) => { if (!fallbackToApiMedia(event)) nativeOnError?.(event); }}
          className={[
            baseImageClassName,
            opacityClassName,
            imageClassName,
            nativeClassName,
          ].filter(Boolean).join(" ")}
        />
      </span>
      <ImageAttribution
        imageUrl={imageUrl}
        scientificName={
          attributionType === "species" ? attributionName : undefined
        }
        itemName={attributionName}
        itemType={attributionType}
        className={attributionClassName}
        position={attributionPosition}
      />
    </>
  );
};

export default ListingImage;
